// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"d52b279f","353":"09a4d65d"}[chunkId] + ".chunk.css";
};